import I18nForLwText from './LwText'

export default class I18nForLwTextarea extends I18nForLwText {
  name = 'lw-textarea'
}
